import { Card, CardHeader, Stack } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout/index.js"
import MaterialTypography from "../../../components/MaterialTypography/index.js"
import MaterialButton from "../../../components/MaterialButton/index.js"
import { Add, FilterAlt } from "@mui/icons-material"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { useSnackbar } from "../../../context/popup.js"
import { useLoading } from "../../../components/Loading/index.js"
import Table from "../../../components/Table/index.js"
import { useEffect, useState } from "react"
import { deleteData, fetchData } from "../../../services/index.js"
import { setCurrentPage, setRowsPerPage, setTotalPages} from "./store/index";
import HealthCategoryFilterDialog from './components/HealthCategoryFilterDialog.js';

const HealthCategoryList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const currentPage = useSelector((state) => state?.healthCategoryStore?.currentPage);
    const rowsPerPage = useSelector((state) => state?.healthCategoryStore?.rowsPerPage);
    const totalPages = useSelector((state) => state?.healthCategoryStore?.totalPages);
    
    const [categoryData, setCategoryData] = useState([]);
    const [isRefresh, setIsRefresh] = useState(false);
    const [search, setSearch] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        isActive: "",
        parentCategoryId: ""
    });

    useEffect(() => {
      fetchApiCategoryList();
    },[isRefresh, currentPage, rowsPerPage, search])

    //List API
    const fetchApiCategoryList = async () => {
        setCircleLoading(true);
        try {
        let url = `/reference/health/key-value-category?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`;
                                    
        //filter
        if(filterData.isActive !== "") {
            url += `&isActive=${filterData.isActive}`;
        }
        if(filterData.parentCategoryId !== "") {
            url += `&parentCategoryId=${filterData.parentCategoryId}`;
        }
        const response = await fetchData(url);
        if(response?.success){
            setCategoryData(response?.data?.items);
            dispatch(setTotalPages(response?.data?.totalPages));     
        }
        else{
            //throw error
            showSnackbar("Error Fetching Workflow List", "error")
        }
        } catch (error) {
            console.error('Error Fetching Insurer Api List:', error);
            showSnackbar(error?.response?.data?.message  || "Network Error", "error")
        }
        finally{
            setCircleLoading(false);
        }
    };

    //delete api function
    const handleDelete = async (row) => {
        try {
            const response = await deleteData(
            `/reference/health/key-value-category-delete`,
            {
                ids: [row?.id],
            }
            );
            setIsRefresh(!isRefresh);

            if (response?.success) {
            showSnackbar(response?.message, "success");
            } else {
            showSnackbar(response?.message, "error");
            }
        } catch (error) {
            console.error("Error deleting data:", error);
            showSnackbar(error?.response?.data?.message || "Network Error", "error");
        }
    };

    const apiCategoryTable = {
        //table columns
        columns : [
            {
            key: "sno",
            label: "S.No",
            renderCell: (row) => row?.sno,
            },
            {
            key: "code",
            label: "Code",
            renderCell: (row) => row?.code,
            },
            {
            key: "categoryName",
            label: "Category Name",
            renderCell: (row) => row?.categoryName,
            },
            {
            key: "createdAt",
            label: "Created At",
            renderCell: (row) => row?.createdAt,
            },
            {
            key: "active",
            label: "Status",
            renderCell: (row) => (
                <span>
                {row?.isActive ? (
                    <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                ) : (
                    <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                )}
                </span>
            ),
            },
        ],
        //table rows
        rows : categoryData.map((category, index) => ({
            ...category,
            sno: index + 1,
            createdAt: new Date(category.createdAt).toLocaleDateString("en-GB"),
        }))
    };

    const actions = {
        view: true,
        edit: true,
        delete: true,
        onDelete: (row) => handleDelete(row),
        onView: (row) => navigate(`/health-master/health-category/category-details?pageType=view&id=${row.id}`),
        onEdit: (row) => navigate(`/health-master/health-category/category-details?pageType=edit&id=${row.id}`),
    };

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleSearch = (value) => {
        setSearch(value);
    };

  return (
    <DashboardLayout>
      <CardHeader
        title={
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
          >
            <Stack direction="column" spacing={0}>
              <MaterialTypography variant="h5" fontWeight="medium">
                Health Key Value Category List
              </MaterialTypography>
              <MaterialTypography variant="caption" color="text">
                List of Key Value Categories in Health Master.
              </MaterialTypography>
            </Stack>

            <Stack direction="row" spacing={1}>
               <MaterialButton
                  variant="gradient"
                  color="dark"
                  size="small"
                  startIcon={<FilterAlt/>}
                  onClick={(event) => setAnchorEl(event.currentTarget)}
                  >
                  Filter
                  </MaterialButton>
              <MaterialButton
                variant="gradient"
                color="dark"
                size="small"
                startIcon={<Add />}
                onClick={() => navigate("/health-master/health-category/category-details")}
              >
                Add Category
              </MaterialButton>
            </Stack>
          </Stack>
        }
      />
      <Card sx={{ mx: 1 }}>
        <Table
          columns={apiCategoryTable?.columns}
          data={apiCategoryTable?.rows}
          actions={actions}
          pagination={{
            totalPages,
            currentPage,
            onPageChange: (page) => handlePaginationChange(page),
            rowsPerPage,
            onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
            rowsPerPageOptions: [5, 10, 15, 20],
            }}
          getRowKey={(row) => row.id}
          className="custom-table"
          noDataLabel={"No API Engine Category data found"}
          handleSearch={handleSearch}
        />
      </Card>
      <HealthCategoryFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);
            fetchApiCategoryList(); 
        }}
        />
    </DashboardLayout>
  )
}

export default HealthCategoryList